import {
  //PKINDEV data
  PKINDEV_RESQUEST,
  PKINDEV_RESPOND,

  //PROJECT
  PROJECT_RESQUEST,
  PROJECT_RESPOND,

  //SUBSCRIPTION
  SUBSCRIPTION_PLAN_REQUEST,
  SUBSCRIPTION_PLAN_SUCCESS,
  SUBSCRIPTION_PLAN_FAILURE,
  PROJECT_PLAN_REQUEST,
  PROJECT_PLAN_RESPOND,

  //TERM & CONDITION /PRIVACY POLICY /REFUND POLICY
  TERMS_REQUEST,
  PRIVACY_REQUEST,
  REFUND_REQUEST,
} from "../actions";

//------------- FUNCTION ------------- //

//PROJECT -------
export const getProject_request = (data) => ({
  type: PROJECT_RESQUEST,
  payload: data,
});
export const getProject_respond = (data) => ({
  type: PROJECT_RESPOND,
  payload: data,
});

//PROJECT_PLAN ------
export const getProject_Plan_request = (data) => ({
  type: PROJECT_PLAN_REQUEST,
  payload: data,
});
export const getProject_Plan_respond = (data) => ({
  type: PROJECT_PLAN_RESPOND,
  payload: data,
});

//PKINDEV COMPANY
export const getPkindevRequest = (data) => ({
  type: PKINDEV_RESQUEST,
  payload: data,
});

export const getPkindevRespond = (data) => ({
  type: PKINDEV_RESPOND,
  payload: data,
});

//ดึงข้อมูล SubscriptionPlan จาก id_subscription_plan_table
export const getSubscription_Plan_Request = (data) => ({
  type: SUBSCRIPTION_PLAN_REQUEST,
  payload: data,
});

export const getSubscription_Plan_Success = (data) => ({
  type: SUBSCRIPTION_PLAN_SUCCESS,
  payload: data,
});

export const getSubscription_Plan_Failure = (error) => ({
  type: SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});

///Term & Condition /Privacy Policy /Refund Policy
export const getTermsRequest = (id_project) => ({
  type: TERMS_REQUEST,
  payload: id_project,
});
export const getPrivacyRequest = (id_project) => ({
  type: PRIVACY_REQUEST,
  payload: id_project,
});
export const getRefundRequest = (id_project) => ({
  type: REFUND_REQUEST,
  payload: id_project,
});
